import React, { useState, useEffect } from "react";
import Base from "../../Config/Base";
import { API_BASE_CRM_URL, API_BASE_URL } from "../../Config/Config";
import "../../Config/loader.css";
import Pagination from "../../Config/Pagination";
import { startOfWeek, startOfMonth, subMonths, subYears } from "date-fns";
import { useLocation, useNavigate } from "react-router-dom";
import "jspdf-autotable";
import { Footer } from "../footer/footer";

export default function SaleByGstdetails() {
  const navigate = useNavigate();

  const getFormattedDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const [fromDate, setFromDate] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [toDate, setToDate] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [customersData, setCustomersData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [MisUserDetails, SetUserDetails] = useState([]);
  const [storesdata, setStoresData] = useState([]);
  const [selectedStore, setSelectedStore] = useState("0");
  const [employeData, setemployeData] = useState([]);
  const [reportdata, setReportData] = useState([]);
  const [selectemploye, setselectemploye] = useState("0");
  const [selectedFromDate, setSelectedFromDate] = useState("");
  const [selectedToDate, setSelectedToDate] = useState(
    getFormattedDate(new Date())
  );
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [salesdata, SetsalesData] = useState([]);
  const location = useLocation();
  const { reportId } = location.state || {};

  useEffect(() => {
    const MisUserDetailsSession = JSON.parse(
      sessionStorage.getItem("MisUserDetails") ||
        localStorage.getItem("MisUserDetails")
    );
    SetUserDetails(MisUserDetailsSession);
  }, []);

  const handleFromDateChange = (e) => {
    setFromDate(e.target.value);
  };

  const handleToDateChange = (e) => {
    setToDate(e.target.value);
  };

  const handleSelectChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedOption(selectedValue);
    calculateFromDate(selectedValue);
  };
  const calculateFromDate = (option) => {
    const today = new Date();
    let newFromDate;

    switch (option) {
      case "This Week":
        newFromDate = startOfWeek(today, { weekStartsOn: 1 });
        break;
      case "This Month":
        newFromDate = startOfMonth(today);
        break;
      case "Last 3 Months":
        newFromDate = subMonths(today, 3);
        break;
      case "1 Year":
        newFromDate = subYears(today, 1);
        break;
      default:
        newFromDate = "";
        break;
    }

    setFromDate(newFromDate);
  };

  useEffect(() => {
    // Set the initial value for From Date to the first of the current month
    const firstDateOfMonth = new Date();
    firstDateOfMonth.setDate(1); // Set date to 1
    setSelectedFromDate(getFormattedDate(firstDateOfMonth)); // Format it

    // Optionally, set To Date to today or another default
    setSelectedToDate(getFormattedDate(new Date()));
  }, []);

  useEffect(() => {
    if (MisUserDetails && MisUserDetails.OrgId) {
      const fetchStoresData = async () => {
        try {
          const response = await fetch(
            `${API_BASE_URL}Settings/getUserStores?OrgId=${MisUserDetails.OrgId}&UserId=${MisUserDetails.UserId}`
          );
          if (response.ok) {
            const data = await response.json();
            if (data) {
              setStoresData(data.ResultData);
            } else {
              console.error("Error fetching data: No result data");
            }
          } else {
            console.error("Error fetching data: ", response.statusText);
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };

      fetchStoresData();
    }
  }, [MisUserDetails]);

  useEffect(() => {
    const fetchReportData = async () => {
      try {
        if (MisUserDetails) {
          const response = await fetch(
            `${API_BASE_URL}report/getreporthead?OrgId=${MisUserDetails.OrgId}&UserId=${MisUserDetails.UserId}&ReportId=${reportId}`
          );

          if (!response.ok) {
            throw new Error("Failed to fetch report data");
          }

          const data = await response.json();
          setReportData(data);
        }
      } catch (err) {
        console.log(err);
      }
    };

    fetchReportData();
  }, [reportId, MisUserDetails]);

  useEffect(() => {
    if (MisUserDetails && MisUserDetails.OrgId) {
      const fetchDDLData = async () => {
        try {
          const response = await fetch(
            `${API_BASE_URL}Admin/getDDl?&LoggedInUser=${MisUserDetails.UserId}&OrgId=${MisUserDetails.OrgId}`
          );
          if (response.ok) {
            const result = await response.json();
            const allData = result.ResultData;

            // Filter only "Staff" data
            const staffData = allData.filter(
              (item) => item.DDLName === "Staff"
            );

            setemployeData(staffData);

            console.log("Staff data saved successfully:", staffData);
          } else {
            console.error("Error fetching data:", response.statusText);
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };

      fetchDDLData();
    }
  }, [MisUserDetails]);

  useEffect(() => {
    const currentDate = new Date().toISOString().split("T")[0];
    setFromDate(currentDate);
  }, []);

  useEffect(() => {
    const currentDate = new Date().toISOString().split("T")[0];
    setToDate(currentDate);
  }, []);

  const fetchGSTDetails = () => {
    if (MisUserDetails && MisUserDetails.OrgId) {
      setLoading(true);

      const requestData = {
        OrgId: MisUserDetails ? MisUserDetails.OrgId : "0",
        UserId: MisUserDetails ? MisUserDetails.UserId : "0",
        ReportId: reportId,
        ReportCriteria: {
          FromDate: fromDate,
          ToDate: toDate,
          ProductId: 0,
          SupplierId: 0,
          UserId: selectemploye ? selectemploye : 0,
          LoginUserId: MisUserDetails ? MisUserDetails.UserId : "0",
          StoreId: selectedStore ? selectedStore : 0,
          CustomerId: 0,
          CategoryId: 0,
          OrgId: MisUserDetails ? MisUserDetails.OrgId : "0",
          // UserId: MisUserDetails ? MisUserDetails.UserId : "0",
          City: 0,
          Status: 0,
          // Status: selectedLocalIndStatus ? selectedLocalIndStatus.value : "0",
        },
      };

      console.log(requestData, "data sending to api");

      fetch(`${API_BASE_URL}report/getreport`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      })
        .then((response) => response.json())
        .then((data) => {
          console.log(data, "response from service");
          if (data && data.data) {
            SetsalesData(data.data);
            console.log(data, "data getting from api");
          } else {
            console.error("Error fetching data:", data);
          }
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          setLoading(false);
        });
    }
  };

  useEffect(() => {
    fetchGSTDetails();
  }, [MisUserDetails]);

  const handleSearch = () => {
    fetchGSTDetails();
  };

  let filteredItems = [];

  if (reportdata && salesdata.length > 0) {
    filteredItems = salesdata.filter(
      (item) =>
        item.ProductName?.toLowerCase().includes(
          (searchTerm || "").toLowerCase()
        ) ||
        item.CategoryName?.toLowerCase().includes(
          (searchTerm || "").toLowerCase()
        )
    );
  }
  const itemsPerPage = 10;

  // Calculate indices for slicing data
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  const handleChange = (event) => {
    setSelectedStore(event.target.value);
  };
  console.log(selectedStore);

  const handleEmpChange = (event) => {
    setselectemploye(event.target.value);
  };

  console.log(salesdata);

  return (
    <Base>
      <div>
        <div className="mb-2">
          <div className="page-title mb-2">
            <h4> GST Details</h4>
            <h6>Sales by GST Details</h6>
          </div>
          <div className="d-flex justify-content-between align-items-center">
            <div className="search-bar col-10">
              <div className="input-group">
                <input
                  type="text"
                  name="search..........."
                  placeholder="Search..."
                  className="form-control"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>
            <button
              onClick={() => setIsFilterVisible(!isFilterVisible)}
              style={{
                background: "none",
                border: "none",
                cursor: "pointer",
              }}
            >
              <i
                className="fa fa-filter"
                style={{ fontSize: "24px", color: "#333" }}
              ></i>
            </button>
          </div>
        </div>
        <div>
          {isFilterVisible && (
            <div className="row g-3 mb-3 mb-0">
              {/* From Date */}
              <div className="col-6 col-lg-3">
                <label className="form-label">From Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={fromDate}
                  onChange={handleFromDateChange}
                />
              </div>

              {/* To Date */}
              <div className="col-6 col-lg-3">
                <label className="form-label">To Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={toDate}
                  onChange={handleToDateChange}
                />
              </div>

              {/* Store Dropdown */}
              <div className="col-6 col-lg-3">
                <label className="form-label">Store</label>
                <select
                  id="store-dropdown"
                  className="form-select"
                  value={selectedStore}
                  onChange={handleChange}
                >
                  <option value="0">-- All --</option>
                  {storesdata.map((store) => (
                    <option key={store.StoreId} value={store.StoreId}>
                      {store.Name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Employee Dropdown */}

              <div className="col-6 col-lg-3">
                <label className="form-label">Employee</label>
                <select
                  id="employee-dropdown"
                  className="form-select"
                  value={selectemploye}
                  onChange={handleEmpChange}
                >
                  <option value="0">-- All --</option>
                  {employeData.map((name) => (
                    <option key={name.ItemId} value={name.ItemId}>
                      {name.DisplayValue}
                    </option>
                  ))}
                </select>
              </div>
              <div
                className="col-12 col-lg-3 mb-0"
                style={{ marginTop: "-15px" }}
              >
                <button
                  className="btn btn-secondary w-100 mt-4"
                  onClick={handleSearch}
                >
                  <i className="fa-solid fa-magnifying-glass"></i> Search
                </button>
              </div>
            </div>
          )}
        </div>
        <div className="card-container mb-5">
          {loading ? (
            <div className="text-center my-5">
              <div className="containers m-auto d-flex justify-content-center align-items-center">
                <div className="dot bg-primary"></div>
                <div className="dot bg-secondary"></div>
                <div className="dot bg-success"></div>
                <div className="dot bg-danger"></div>
                <div className="dot bg-warning"></div>
                <div className="dot bg-info"></div>
              </div>
              <p>Loading...</p>
            </div>
          ) : (
            <div className="row mb-2">
              {currentItems &&
                currentItems.map((item, index) => (
                  <div key={index} className="col-md-6">
                    <div
                      className="store-card card shadow-sm my-1"
                      style={{
                        border: "1px solid #ddd",
                        borderRadius: "8px",
                        padding: "1px",
                      }}
                    >
                      <div className="card-body">
                        <h5
                          className="card-title d-flex align-items-center mb-3"
                          style={{ marginRight: "5px", color: "#007bff" }}
                        >
                          {item.ProductName}
                        </h5>
                        <div className="card-details">
                          <div
                            className="row"
                            style={{ color: "#6c757d", marginTop: "10px" }}
                          >
                            <div className="col-6">
                              <span>
                                <strong>
                                  <i
                                    className="fa-solid fa-shop me-2"
                                    style={{ color: "#007bff" }}
                                  ></i>
                                </strong>{" "}
                                {item.CategoryName}
                              </span>
                            </div>
                            <div className="col-6">
                              <span>
                                <strong>
                                  <i
                                    className="fa-solid fa-calendar-days me-2"
                                    style={{ color: "#007bff" }}
                                  ></i>
                                </strong>{" "}
                                {formatDate(item.OrderDate)}
                              </span>
                            </div>
                          </div>
                          <div
                            className="row"
                            style={{ color: "#6c757d", marginTop: "10px" }}
                          >
                            <div className="col-6">
                              <span>
                                <strong>
                                  <i
                                    className="fa-solid fa-money-bill me-2"
                                    style={{ color: "#007bff" }}
                                  ></i>
                                </strong>{" "}
                                {item.OrderdetailTotal}
                              </span>
                            </div>
                            <div className="col-6">
                              <span>
                                <strong>
                                  <i
                                    className="fa-solid fa-temperature-quarter me-2"
                                    style={{ color: "#007bff" }}
                                  ></i>
                                  Qty:
                                </strong>{" "}
                                {item.Quantity}
                              </span>
                            </div>
                          </div>

                          {/* Second row: CGST, SGST, IGST */}
                          <div
                            className="row"
                            style={{ color: "#6c757d", marginTop: "10px" }}
                          >
                            <div className="col-4">
                              <span>
                                <strong>
                                  <i
                                    className="fa-solid fa-file-invoice me-2"
                                    style={{ color: "#007bff" }}
                                  ></i>
                                  CGST:
                                </strong>{" "}
                                {item.CGST || 0}
                              </span>
                            </div>
                            <div className="col-4">
                              <span>
                                <strong>
                                  <i
                                    className="fa-solid fa-file-invoice me-2"
                                    style={{ color: "#007bff" }}
                                  ></i>
                                  SGST:
                                </strong>{" "}
                                {item.SGST || 0}
                              </span>
                            </div>
                            <div className="col-4">
                              <span>
                                <strong>
                                  <i
                                    className="fa-solid fa-file-invoice me-2"
                                    style={{ color: "#007bff" }}
                                  ></i>
                                  IGST:
                                </strong>{" "}
                                {item.IGST || 0}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          )}
          <Pagination
            itemsPerPage={itemsPerPage}
            totalItems={filteredItems.length}
            paginate={paginate}
            currentPage={currentPage}
          />
        </div>
      </div>
      <br />
      <br />
      <br />
      <Footer></Footer>
    </Base>
  );
}
